import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Page } from "./types";
import Footer from "components/Footer/Footer";
import PageHome from "app/(home)/page";
import PageArchiveVideo from "app/(archives)/videos/page";
import PageSingleVideo from "app/(singles)/(default)/video/page";
import PageAbout from "app/apropos/page";
import PageCalendrier from "app/calendrier/PageCalendrier";
import PageCarteVelo from "app/carte/PageCarteVelo";
import PageAjouterEvenement from "app/calendrier/PageAjouterEvenement";
import PageSupprimerEvenement from "app/calendrier/PageSupprimerEvenement";
import PageAchat from "app/achat/PageAchat";
import PageMerci from "app/merci/PageMerci"
import PagePropositions from "app/propositions/PagePropositions";
import PageConseils from "app/conseils/PageConseils";
import PageEvenements from "app/evenements/PageEvenements";
import PageProjets from "app/projets/PageProjets";
import PageArticle from "app/article/PageArticle";
import PageServices from "app/services/page";
import PagePhotos from "app/photos/PagePhotos";
import PageContact from "app/(others)/contact/page";
import Page404 from "app/not-found";
import SiteHeader from "app/SiteHeader";
import PageInfolettre from "app/infolettre/Infolettre";
import PageArticles from "app/articles/PageArticles";
import PageMedias from "app/Medias/PageMedias";
import PagePDF from "app/pdf/PagePDF";
import PageRegister from "app/register/PageRegister";
import PageLogin from "app/login/PageLogin";
import PageModifierArticle from "app/admin/PageModifierArticle";
import PageAjouterArticle from "app/admin/PageAjouterArticle";
import PageAjouterProjet from "app/admin/PageAjouterProjet";
import PageListeProjets from "app/admin/PageListeProjets";
import PageSommaire from "app/admin/PageSommaire";
import PageProjet from "app/admin/PageProjet";
import PageAjouterInfolettre from "app/admin/PageAjouterInfolettre";
import PageAjouterVideo from "app/admin/PageAjouterVideo";
import PageCreerInfolettre from "app/admin/PageCreerInfolettre";
import PageEnvoyerInfolettre from "app/admin/PageEnvoyerInfolettre";
import PageAdmin from "app/admin/PageAdmin";
import PageUsagers from "app/admin/PageUsagers";
import ListeImages from "app/listeImages/ListeImages";
import PageRecherche from "app/recherche/PageRecherche";
import PageProfil from "app/admin/PageProfil";
import PageCommentaires from "app/admin/PageCommentaires";
import SitemapGenerator from "app/sitemap/SitemapGenerator";
import JeuVelo from "app/jeux/Velo";
import PagePolitiqueConfidentialiteCapsules from "app/politique-confidentialite-capsules/PagePolitiqueConfidentialiteCapsules";

export const pages: Page[] = [
  { path: "/", component: PageHome },

  // archives page -------------------------------------------------------

  { path: "/videos/*", component: PageArchiveVideo },

  // single page -------------------------------------------------------

  { path: "/video/*", component: PageSingleVideo },
  { path: "/article/*", component: PageArticle },
  { path: "/pdf/*", component: PagePDF },
  { path: "/recherche/*", component: PageRecherche },

  // other pages -------------------------------------------------------
  
  { path: "/apropos", component: PageAbout },
  { path: "/calendrier", component: PageCalendrier },
  { path: "/carte", component: PageCarteVelo },
  { path: "/ajouterEvenement", component: PageAjouterEvenement },
  { path: "/supprimerEvenement", component: PageSupprimerEvenement },
  { path: "/dons", component: PageAchat },
  { path: "/merci", component: PageMerci },
  { path: "/medias", component: PageMedias },
  { path: "/propositions", component: PagePropositions },
  { path: "/evenements", component: PageEvenements },
  { path: "/projets", component: PageProjets },
  { path: "/conseils", component: PageConseils },
  { path: "/articles", component: PageArticles },
  { path: "/infolettre", component: PageInfolettre },
  { path: "/services", component: PageServices },
  { path: "/photos", component: PagePhotos },
  { path: "/contact", component: PageContact },
  { path: "/listeImages", component: ListeImages },
  { path: "/register", component: PageRegister },
  { path: "/login", component: PageLogin },
  { path: "/admin", component: PageAdmin },
  { path: "/admin/profil", component: PageProfil },
  { path: "/admin/gestionUsagers", component: PageUsagers },
  { path: "/admin/modifierArticle", component: PageModifierArticle },
  { path: "/admin/ajouterArticle", component: PageAjouterArticle },
  { path: "/admin/ajouterProjet", component: PageAjouterProjet },
  { path: "/admin/listeProjets", component: PageListeProjets },
  { path: "/admin/sommaire", component: PageSommaire },
  { path: "/admin/creerInfolettre", component: PageCreerInfolettre },
  { path: "/admin/projets/:id", component: PageProjet },
  { path: "/admin/ajouterInfolettre", component: PageAjouterInfolettre },
  { path: "/admin/envoyerInfolettre", component: PageEnvoyerInfolettre },
  { path: "/admin/ajouterVideo", component: PageAjouterVideo },
  { path: "/commentaires", component: PageCommentaires },
  { path: "/sitemap", component: SitemapGenerator },
  { path: "/jeux/velo", component: JeuVelo },
  { path: "/politique-confidentialite-capsules", component: PagePolitiqueConfidentialiteCapsules },
  { path: "/page404", component: Page404 },

];

const MyRoutes = () => {
 
  return (
   
    <BrowserRouter >
      <SiteHeader />
      <Routes>
        {    
          pages.map(({ component: Component, path }, index) => {
            return <Route  key={index} element={<Component />} path={path} />;
        })
        
        }
        <Route path="*" element={<Page404 />} />
      </Routes>
     
      <Footer />
    </BrowserRouter>

  );
};

export default MyRoutes;
